import {
  MAX_CONTACT_ENTRIES,
  createEmptyContactEntry,
  defaultContactEntryLabel,
  formatContactEntrySummary,
  normalizeContactEntries,
  primaryContactEntry,
  primaryContactEntryValue,
  resolveContactEntriesFromData,
  contactEntryKey,
} from './contactEntries';

export const MAX_CONTACT_EMAILS = MAX_CONTACT_ENTRIES;

function emailDedupeKey(value) {
  return String(value || '').trim().toLowerCase();
}

export function normalizeContactEmails(values) {
  return normalizeContactEntries(values, emailDedupeKey);
}

export function resolveContactEmailsFromData(data = {}) {
  return resolveContactEntriesFromData(data, {
    arrayField: 'emails',
    legacyField: 'email',
    dedupeKeyForValue: emailDedupeKey,
  });
}

export function primaryContactEmail(emails = []) {
  return primaryContactEntryValue(emails);
}

export function formatContactEmailsSummary(emails = []) {
  return formatContactEntrySummary(emails);
}

export { createEmptyContactEntry, defaultContactEntryLabel, primaryContactEntry, contactEntryKey };
